/**
 * Exercices du programme.
 * Lectures sur les routes utilisateur, suppressions sur ADMIN_URLS.content.
 *
 * Extrait de l'ancien services/api.ts (Lot 8, déplacement pur).
 */

import {
  Exercice,
} from '../types';
import type { ApiResponse, DataResponse } from '../types/api';
import { ADMIN_URLS } from '../config/adminApi';
import { createApiClient, presentParams, withEnv } from '../lib/http';
import { AppEnvironment } from '../config/environment';

const api = createApiClient();

export class ExercicesApiService {
  /** Liste les exercices de l'environnement. */
  static async getExercices(env: AppEnvironment): Promise<Exercice[]> {
    const response = await api.get<DataResponse<Exercice[]>>(`/exercices`, withEnv(env));
    return response.data.data;
  }

  /** Recherche les exercices de l'environnement selon des filtres. */
  static async getExercicesByFilters(
    env: AppEnvironment,
    filters: { classeId?: string; matiereId?: string; chapitreId?: string; leconId?: string } = {}
  ): Promise<Exercice[]> {
    const params = presentParams({ ...filters });
    const response = await api.get<DataResponse<Exercice[]>>('/exercices', withEnv(env, { params }));
    return response.data.data;
  }

  /** Lit un exercice par son identifiant. */
  static async getExerciceById(env: AppEnvironment, id: string): Promise<Exercice> {
    const response = await api.get<DataResponse<Exercice>>(`/exercices/${id}`, withEnv(env));
    return response.data.data;
  }

  /** Crée un exercice. */
  static async createExercice(env: AppEnvironment, exercice: Omit<Exercice, 'id'>): Promise<ApiResponse<Exercice>> {
    const response = await api.post<ApiResponse<Exercice>>(`/exercices`, exercice, withEnv(env));
    return response.data;
  }

  /** Met à jour un exercice. */
  static async updateExercice(env: AppEnvironment, id: string, exercice: Partial<Exercice>): Promise<ApiResponse<Exercice>> {
    const response = await api.put<ApiResponse<Exercice>>(`/exercices/${id}`, exercice, withEnv(env));
    return response.data;
  }

  /** Supprime un exercice. */
  static async deleteExercice(env: AppEnvironment, id: string): Promise<ApiResponse<void>> {
    const response = await api.delete<ApiResponse<void>>(`${ADMIN_URLS.content}/exercices/${id}`, withEnv(env));
    return response.data;
  }
}

export default ExercicesApiService;
